/**
 * What a finished commit left out because of internal holds (GDN-4065), read
 * from the operation status. The server reports it as a completion snapshot:
 * zero while the run is processing. Counts are complete; the row lists stop at
 * 200. Held-dependency rows are ALSO counted in `results_failed_count`.
 */
import type { GetImportOperationStatusApiResponse } from '@store/generated/admin';

type HeldFields = Pick<
  GetImportOperationStatusApiResponse,
  | 'results_held_count'
  | 'results_held_rows'
  | 'results_held_dependency_count'
  | 'results_held_dependency_rows'
>;

export function readHeldResults(result: HeldFields) {
  return {
    count: result.results_held_count ?? 0,
    rows: result.results_held_rows ?? [],
    dependencyCount: result.results_held_dependency_count ?? 0,
    dependencyRows: result.results_held_dependency_rows ?? [],
  };
}
